<div class="column drawer-dialog">
	<div class="drawer-dialog-header display-flex-end">
		<h2 i18n="@@auditLogFilterDialog-Title">Audit Log</h2>
		<button mat-icon-button data-automation-id="audit-log-filter-close-button">
			<mat-icon class="color-primary" (click)="onCloseDialog()" data-automation-id="audit-log-filter-close-icon"
				>close</mat-icon
			>
		</button>
	</div>

	<mat-dialog-content class="drawer-dialog-content">
		<!-- Date & Time -->
		<div class="drawer-dialog-content-header-container">
			<h3 class="drawer-dialog-content-header" i18n="@@auditLogFilterDialog-timeframe">Timeframe</h3>
			<span class="required-asterisk">*</span>
		</div>
		<div class="row" style="flex-wrap: nowrap">
			<mat-form-field appearance="outline" class="column date-box" subscriptSizing="dynamic">
				<input
					matInput
					[matDatepicker]="startDatePicker"
					[placeholder]="'MM/DD/YYYY' | accessDatePlaceholderPipe"
					(dateChange)="onDateStartDateChanged($event)"
					[ngModel]="this.auditLogFilters.utcStartDate"
					[max]="getMaxStartDate()"
					data-automation-id="start-date-input"
					required
				/>
				<mat-datepicker-toggle
					matSuffix
					class="date-picker-primary-blue"
					[for]="startDatePicker"
					data-automation-id="start-date-toggle"
				>
					<mat-icon matDatepickerToggleIcon class="calendar-icon" svgIcon="sl-nav-calendar"></mat-icon>
				</mat-datepicker-toggle>
				<mat-datepicker #startDatePicker data-automation-id="start-date-datepicker"></mat-datepicker>
			</mat-form-field>

			<div
				style="display: flex; flex-direction: column; justify-content: center; padding: 0 24px"
				i18n="@@auditLogFilterDialog-to"
			>
				To
			</div>

			<mat-form-field appearance="outline" class="column date-box" subscriptSizing="dynamic">
				<input
					matInput
					[matDatepicker]="endDatePicker"
					[placeholder]="'MM/DD/YYYY' | accessDatePlaceholderPipe"
					(dateChange)="onDateEndDateChanged($event)"
					[ngModel]="this.auditLogFilters.utcEndDate"
					[min]="getMinEndDate()"
					data-automation-id="end-date-input"
				/>
				<mat-datepicker-toggle
					matSuffix
					class="date-picker-primary-blue"
					[for]="endDatePicker"
					data-automation-id="end-date-toggle"
				>
					<mat-icon matDatepickerToggleIcon class="calendar-icon" svgIcon="sl-nav-calendar"></mat-icon>
				</mat-datepicker-toggle>
				<mat-datepicker #endDatePicker data-automation-id="end-date-datepicker"></mat-datepicker>
			</mat-form-field>
		</div>
		@if (this.dateRangeWarning) {
			<div class="row">
				<span class="warning-text" i18n="@@auditLogFilterDialog-dateRangeWarning"
					>Date ranges are limited to 6 months maximum.</span
				>
			</div>
		}
		<mat-divider class="margin-top-16"></mat-divider>

		<!-- Performed By -->
		@if (!isFieldHidden('performedByName')) {
			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@auditLogFilterDialog-performedBy">Performed By</h3>
				<app-multi-select-typeahead
					data-automation-id="performed-by-typeahead"
					[allDropdownOptions]="this.performedByOptions"
					[filterOnField]="'displayName'"
					[placeholderText]="this.performedByMultiSelectSearchPlaceholder"
					[showSelectionsInInputField]="false"
					[showSelectedItemSubOption]="false"
					[selectedItemIconName]="'sl-add-user'"
					[initiallySelectedItemIds]="this.performedById"
					[initiallySelectedIdField]="'id'"
					[minCharactersForSearch]="3"
					[resetTrigger]="resetTrigger"
					(selectedOptionsChangedEvent)="onSelectedItemsChanged('performedBy', $event)"
					(searchInputChanged)="onSearchInput('performedBy', $event)"
				>
				</app-multi-select-typeahead>
				<mat-divider></mat-divider>
			</div>
		}

		<!-- From Company -->
		@if (!isFieldHidden('performedByCompany')) {
			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@auditLogFilterDialog-fromCompany">From Company</h3>
				<app-multi-select-typeahead
					data-automation-id="from-company-typeahead"
					[allDropdownOptions]="this.fromCompanyOptions"
					[filterOnField]="'name'"
					[placeholderText]="this.fromCompanyMultiSelectSearchPlaceholder"
					[showSelectionsInInputField]="false"
					[showSelectedItemSubOption]="false"
					[selectedItemIconName]="'sl-nav-work'"
					[initiallySelectedItemIds]="this.fromCompanyId"
					[initiallySelectedIdField]="'id'"
					[minCharactersForSearch]="3"
					[resetTrigger]="resetTrigger"
					(selectedOptionsChangedEvent)="onSelectedItemsChanged('fromCompany', $event)"
					(searchInputChanged)="onSearchInput('fromCompany', $event)"
				>
				</app-multi-select-typeahead>
				<mat-divider></mat-divider>
			</div>
		}

		<!-- User -->
		@if (!isFieldHidden('user')) {
			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@auditLogFilterDialog-user">User</h3>
				<app-multi-select-typeahead
					data-automation-id="user-typeahead"
					[allDropdownOptions]="this.userOptions"
					[filterOnField]="'displayName'"
					[placeholderText]="this.userMultiSelectSearchPlaceholder"
					[showSelectionsInInputField]="false"
					[showSelectedItemSubOption]="false"
					[selectedItemIconName]="'sl-add-user'"
					[initiallySelectedItemIds]="this.userId"
					[initiallySelectedIdField]="'id'"
					[minCharactersForSearch]="3"
					[resetTrigger]="resetTrigger"
					(selectedOptionsChangedEvent)="onSelectedItemsChanged('user', $event)"
					(searchInputChanged)="onSearchInput('user', $event)"
				>
				</app-multi-select-typeahead>
				<mat-divider></mat-divider>
			</div>
		}

		<!-- Company -->
		@if (!isFieldHidden('company')) {
			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@auditLogFilterDialog-company">Company</h3>
				<app-multi-select-typeahead
					data-automation-id="company-typeahead"
					[allDropdownOptions]="this.companyOptions"
					[filterOnField]="'name'"
					[placeholderText]="this.companyMultiSelectSearchPlaceholder"
					[showSelectionsInInputField]="false"
					[showSelectedItemSubOption]="false"
					[selectedItemIconName]="'sl-nav-work'"
					[initiallySelectedItemIds]="this.companyId"
					[initiallySelectedIdField]="'id'"
					[minCharactersForSearch]="3"
					[resetTrigger]="resetTrigger"
					(selectedOptionsChangedEvent)="onSelectedItemsChanged('company', $event)"
					(searchInputChanged)="onSearchInput('company', $event)"
				>
				</app-multi-select-typeahead>
				<mat-divider></mat-divider>
			</div>
		}

		<!-- Device -->
		@if (!isFieldHidden('device')) {
			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@auditLogFilterDialog-device">Device</h3>
				<app-multi-select-typeahead
					data-automation-id="device-typeahead"
					[allDropdownOptions]="this.deviceOptions"
					[filterOnField]="'serialNumber'"
					[placeholderText]="this.deviceMultiSelectSearchPlaceholder"
					[showSelectionsInInputField]="false"
					[showSelectedItemSubOption]="false"
					[selectedItemIconName]="'sl-lock'"
					[initiallySelectedItemIds]="this.deviceId"
					[initiallySelectedIdField]="'id'"
					[minCharactersForSearch]="3"
					[resetTrigger]="resetTrigger"
					(selectedOptionsChangedEvent)="onSelectedItemsChanged('device', $event)"
					(searchInputChanged)="onSearchInput('device', $event)"
				>
				</app-multi-select-typeahead>
				<mat-divider></mat-divider>
			</div>
		}

		<!-- Device Group -->
		@if (!isFieldHidden('deviceGroup')) {
			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@auditLogFilterDialog-deviceGroup">Device Group</h3>
				<app-multi-select-typeahead
					data-automation-id="device-group-typeahead"
					[allDropdownOptions]="this.deviceGroupOptions"
					[filterOnField]="'name'"
					[placeholderText]="this.deviceGroupMultiSelectSearchPlaceholder"
					[showSelectionsInInputField]="false"
					[showSelectedItemSubOption]="false"
					[selectedItemIconName]="'sl-lock'"
					[initiallySelectedItemIds]="this.deviceGroupId"
					[initiallySelectedIdField]="'id'"
					[minCharactersForSearch]="3"
					[resetTrigger]="resetTrigger"
					(selectedOptionsChangedEvent)="onSelectedItemsChanged('deviceGroup', $event)"
					(searchInputChanged)="onSearchInput('deviceGroup', $event)"
				>
				</app-multi-select-typeahead>
				<mat-divider></mat-divider>
			</div>
		}

		<!-- Property -->
		@if (!isFieldHidden('property')) {
			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@auditLogFilterDialog-property">Property</h3>
				<app-multi-select-typeahead
					data-automation-id="property-typeahead"
					[allDropdownOptions]="this.propertyOptions"
					[filterOnField]="'name'"
					[placeholderText]="this.propertyMultiSelectSearchPlaceholder"
					[showSelectionsInInputField]="false"
					[showSelectedItemSubOption]="false"
					[selectedItemIconName]="'sl-nav-location'"
					[initiallySelectedItemIds]="this.propertyId"
					[initiallySelectedIdField]="'id'"
					[minCharactersForSearch]="3"
					[resetTrigger]="resetTrigger"
					(selectedOptionsChangedEvent)="onSelectedItemsChanged('property', $event)"
					(searchInputChanged)="onSearchInput('property', $event)"
				>
				</app-multi-select-typeahead>
				<mat-divider></mat-divider>
			</div>
		}

		<!-- Details -->
		@if (!isFieldHidden('details')) {
			<div>
				<h3 class="drawer-dialog-content-header" i18n="@@auditLogFilterDialog-details">Details</h3>
				<app-multi-select-typeahead
					data-automation-id="details-typeahead"
					[allDropdownOptions]="this.detailsOptions"
					[filterOnField]="'name'"
					[placeholderText]="this.detailsMultiSelectSearchPlaceholder"
					[showSelectionsInInputField]="false"
					[showSelectedItemSubOption]="false"
					[selectedItemIconName]="'sl-description'"
					[initiallySelectedItemIds]="this.detailsId"
					[initiallySelectedIdField]="'id'"
					[minCharactersForSearch]="3"
					[resetTrigger]="resetTrigger"
					(selectedOptionsChangedEvent)="onSelectedItemsChanged('details', $event)"
					(searchInputChanged)="onSearchInput('details', $event)"
				>
				</app-multi-select-typeahead>
			</div>
		}
	</mat-dialog-content>

	<mat-dialog-actions class="margin-bottom-none">
		<div class="row content-flex-end">
			<div class="bottom-border"></div>
			<button
				mat-button
				class="secondary-button"
				i18n="@@auditLogFilterDialog-cancel"
				(click)="onCloseDialog()"
				data-automation-id="audit-log-filter-cancel-button"
			>
				Cancel
			</button>
			<button
				mat-button
				class="secondary-cancel-button"
				i18n="@@auditLogFilterDialog-clearAll"
				(click)="onClearAll()"
				data-automation-id="audit-log-filter-clear-button"
			>
				Clear All
			</button>
			<button
				mat-button
				class="primary-button"
				style="margin-right: 24px"
				(click)="onGenerateReport()"
				[disabled]="!auditLogFilters.utcStartDate"
				data-automation-id="audit-log-filter-generate-button"
			>
				{{ this.primaryButtonText }}
			</button>
		</div>
	</mat-dialog-actions>
</div>
